















import { listFactory } from '@/main/pages/listFactory';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				rabatSk: `${this.storeUri}/${listMutations.SLEVAMAT_RABAT_SK_FILTER_SELECT_MAPPER}`,
			};
		},
		rabatSkFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
	},
});
